
import ChartSuccess from "../../../assets/duotone/ChartSuccess.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ChartSuccessIcon({ className, dataTestid = "ChartSuccessIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ChartSuccess data-testid={dataTestid} className={classes} {...rest} />
  );
}
